export { LoginPage as default } from '@moonpig/web-purchase-auth'
